import React from "react"
import { DebounceInput } from "react-debounce-input"
import { injectIntl } from "react-intl"

import { ProductCustomAttributesTextInputComponentProps } from "../../../../../../../common/types"
import IntlProps from "../../../../../../../state/helpers/IntlProps"
import { CUSTOM_ATTRIBUTE_TYPE_TEXT } from "../../../../../../../utils"

const ProductCustomAttributesTextInputComponent = (props: ProductCustomAttributesTextInputComponentProps & IntlProps) => {

    if (props.isPdf || !props.isEditable && props.displayValues) {
        return (
            <div className="mb-3">
                <div>
                    <label className="col-sm-2 col-form-label">
                        {`${props.label || ""}`}
                        {props.isRequired &&
                            <span>
                                <span className="text-danger">*</span>
                            </span>
                        }
                        <span>:</span>
                    </label>
                    <span className="col-sm-8">{props.customValue}</span>
                </div>
                {!props.hideDivider && <hr className="hr" />}
            </div>
        )
    }

    return <div>
        <label className="col-sm-9 col-form-label">{props.label}
        </label>
        <DebounceInput
            minLength={0}
            debounceTimeout={500}
            className="form-control col-sm-8 mx-3"
            required={props.isRequired}
            onChange={(event) =>
                props.onHandleCustomAttributeChange({
                    allowMoreThanOneChoice: false,
                    attributeType: CUSTOM_ATTRIBUTE_TYPE_TEXT.value,
                    value: event.target.value,
                    itemId: props.itemId,
                    customAttributeDefinitionId: props.customAttributeDefinitionId,
                    actionType: null
                })
            }
            value={props.customValue}
            disabled={props.isEditPriceListTemplate ? true : !props.isEditable}
        />
        {!props.hideDivider && <hr className="hr" />}
    </div>
}

export default injectIntl(ProductCustomAttributesTextInputComponent)


// WEBPACK FOOTER //
// ./src/template/sections/content/pricing-table/product-custom-attribute/components/productCustomAttributesTextInput/ProductCustomAttributesTextInputComponent.tsx